/* CertiClear predictive search — loaded by sections/header.liquid only.
   Split out of assets/global.js so the cart, blog and account pages no longer
   parse it. Binds to the header search form's [data-predictive-*] hooks. */

(function () {
  'use strict';

  var form = document.querySelector('[data-predictive-search]');
  if (!form) return;
  var input = form.querySelector('[data-predictive-input]');
  var results = form.querySelector('[data-predictive-results]');
  if (!input || !results) return;
  var timer = null;
  var lastQuery = '';

  function close() {
    results.hidden = true;
    results.innerHTML = '';
  }

  function render(query, products) {
    var html = '';
    products.forEach(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url + '&width=80" alt="" width="40" height="40" loading="lazy">'
        : '';
      html += '<a class="predictive-results__item" href="' + p.url + '">' + img +
        '<span class="predictive-results__title">' + p.title + '</span>' +
        '<span class="predictive-results__price">' + (p.price ? '$' + p.price : '') + '</span></a>';
    });
    html += '<a class="predictive-results__all" href="/search?q=' + encodeURIComponent(query) + '">See all results for “' + query.replace(/</g, '&lt;') + '” →</a>';
    results.innerHTML = html;
    results.hidden = false;
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(timer);
    if (query.length < 2) { close(); return; }
    timer = setTimeout(function () {
      lastQuery = query;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (query !== lastQuery) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0 && query.length < 3) { close(); return; }
          render(query, products);
        })
        .catch(close);
    }, 250);
  });

  document.addEventListener('click', function (event) {
    if (!form.contains(event.target)) close();
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { close(); input.blur(); }
  });
})();
